<template>
  <div class="baijiayun">
    <app-header v-if="appUser.isNative" title="友邻少年" back-type="back-app" />
    <div class="baijiayun-main" :class="{ 'live-detail': type === 3 }" v-if="type">
      <LiveMain v-if="type === 3" :detail="detail" @getDetail="getLiveDetail"></LiveMain>
      <template v-else>
        <iframe v-if="liveUrl" class="baijiayun-ifram" :src="liveUrl" frameborder="0"></iframe>
        <template v-else>
          <div class="no-live">
            <img src="@/assets/images/no_live.png" alt="" />
          </div>
          <div class="message">
            {{ errorMessage || '您无法观看此直播' }}
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import baijiayun from '@/api/modules/payment/baijiayue'
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import { toLoginView } from '@/utils/init/env-init'
import LiveMain from '@/components/liveMain/index.vue'
import { appUser } from '@/utils'
const action = 'baijiayunLive'

export default {
  components: { LiveMain },
  mixins: [Body],
  data() {
    return {
      liveUrl: '',
      errorMessage: '',
      type: null, //1有权限 2报错 3未开始预约
      detail: {},
      appUser
    }
  },
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  watch: {},
  created() {
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getLiveDetail()
  },
  mounted() {},
  methods: {
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      this.getLiveDetail()
    },
    getLiveDetail() {
      baijiayun
        .getLiveDetail({ shareCode: this.shareCode, roomId: this.$route.query.roomId })
        .then(res => {
          console.log(res, 'opop')
          let newStr = new Date() * 1
          let startStr = new Date(res.startTime) * 1 - res.preViewSeconds * 1000
          console.log(newStr, startStr, 'opop')
          if (newStr < startStr) {
            this.type = 3
            this.detail = res
          } else {
            this.getLiveSign()
          }
        })
        .catch(error => {
          console.log(error)
          this.type = 2
          this.errorMessage = error.message
        })
    },
    getLiveSign() {
      baijiayun
        .getLiveSign({ shareCode: this.shareCode, roomId: this.$route.query.roomId })
        .then(res => {
          this.liveUrl = `https://${res.privateDomainPrefix}.at.baijiayun.com/web/room/enter?room_id=${
            res.room_id
          }&user_number=${res.user_number}&user_name=${encodeURI(res.user_name)}&user_role=${
            res.user_role
          }&user_avatar=${encodeURI(res.user_avatar)}&sign=${res.sign}&group_id=${res.group_id}`
          console.log(this.liveUrl, 'sign')
          this.type = 1
        })
        .catch(error => {
          console.log(error)
          this.type = 2
          this.errorMessage = error.message
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.baijiayun {
  width: 100%;
  height: 100%;
}
.baijiayun-main,
.baijiayun-ifram {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;
  .no-live {
    width: 249px;
    height: 212px;
    margin-bottom: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .message {
    font-size: 16px;
    color: #999;
  }
}
.live-detail {
  justify-content: flex-start;
  padding: 16px;
}
</style>
